// default params state
export const initParams = {
    'apiURL': '',
    'token': '',
    'mode': '',
    'clientID': '',
    'advisorEmail': '',
};

// params reducer
const params = (state) => {
  if(state === undefined) {
    return {};
  }
  return state;
};

export default params;



// WEBPACK FOOTER //
// ./src/reducers/params.js